import { render, staticRenderFns } from "./user_dp_pj.vue?vue&type=template&id=5aab5fc0&scoped=true"
import script from "./user_dp_pj.vue?vue&type=script&lang=js"
export * from "./user_dp_pj.vue?vue&type=script&lang=js"
import style0 from "./user_dp_pj.vue?vue&type=style&index=0&id=5aab5fc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aab5fc0",
  null
  
)

export default component.exports